import { ChecklistResponse } from "@common/api/ping";
import { makeObservable, observable } from "mobx";

export class ChecklistRegistry {
  _checklists: ChecklistResponse[] = [];

  constructor() {
    makeObservable(this, {
      _checklists: observable.ref,
    });
  }

  setChecklists(checklists: ChecklistResponse[]) {
    this._checklists = checklists;
  }

  findById(id: string) {
    return this._checklists.find((checklist) => checklist.id === id);
  }

  get checklists(): ChecklistResponse[] {
    return this._checklists;
  }
}
